import type { Plan } from "@circle-react/types";

import { t } from "@/i18n-js/instance";
import {
  getPreviousTier,
  getTierDisplayName,
  isUpgrading,
  type PlanTiers,
} from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { PlanFeatures } from "./PlanFeatures";

interface PlanCardHighlightsProps {
  plan: Plan;
}

const getFeaturesListTitle = (tier: PlanTiers) => {
  if (tier === "basic") {
    return t(
      "pricing_plans.plan_settings.plan_selection.plan_selector.plan_card.core_features",
    );
  }

  if (tier === "professional") {
    return t(
      "pricing_plans.plan_settings.plan_selection.plan_selector.plan_card.professional_features",
    );
  }

  return t(
    "pricing_plans.plan_settings.plan_selection.plan_selector.plan_card.everything_plus",
    {
      tier: getTierDisplayName(getPreviousTier(tier) ?? ""),
    },
  );
};

export const PlanCardHighlights = ({ plan }: PlanCardHighlightsProps) => {
  const { currentPlanTier, isCommunityOnTrial } = usePlanStatus();
  const shouldHighlightFeatures = Boolean(
    isCommunityOnTrial ||
    (currentPlanTier && isUpgrading(currentPlanTier, plan.tier)),
  );

  const featuresListTitle = getFeaturesListTitle(plan.tier);

  return (
    <PlanFeatures
      planTier={plan.tier}
      title={featuresListTitle}
      isOnOffer={Boolean(plan.is_on_offer)}
      shouldHighlightFeatures={shouldHighlightFeatures}
    />
  );
};
